import StatementDetailsReducer from "@bToC/Store/Pages/StatementDetails/StatementDetailsReducer";
import StatementsPageReducer from "@bToC/Store/Pages/Statements/StatementsPageReducer";
import { combineReducers } from "redux";

const reducers = {
    statementDetails: StatementDetailsReducer,
    statements: StatementsPageReducer,
};

export type CustomPagesReducers = typeof reducers;

const customPagesReducer = combineReducers(reducers);

export default customPagesReducer;
